import Vue, { VueConstructor } from 'vue';
import generatedApi from './_generated/generated-api';

export default {
  install: (VuePlugin: VueConstructor, options: any) => {
    VuePlugin.$guards.waitForAppLoad().then(() => {
      const otherApi = VuePlugin.$service.v2.api ?? {};
      // This way no essential core services are ever lost, but new ones can be added from the outside
      // It also allows for overriding of existing core services
      const coreApi = { core: { ...generatedApi(), ...(otherApi?.core ?? {}) } };
      VuePlugin.$service.v2.api = { ...otherApi, ...coreApi };
      VuePlugin.prototype.$service.v2.api = Vue.$service.v2.api;
    });
  },
};

export type CoreServiceAPIV2 = { core: ReturnType<typeof generatedApi> };
